import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { QueryOptionsOmit } from 'litto-lib/types';

import { ILocation } from '../interfaces';
import { IHydraError } from '../interfaces/hydraError';
import { getLocation } from '../location';


type UseGetLocationQueryOptions = QueryOptionsOmit<
	UseQueryOptions<ILocation, AxiosError<IHydraError>, ILocation>
>;

export function useGetHomepageExperiences(
	code: string,
	config?: UseGetLocationQueryOptions
) {
	return useQuery(
		['homepage-experiences'],
		() => getLocation(code),
		config as any
	);
}
